import React from "react";

export default function BikeparkTrail(props: any) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M1.60661 17.916C1.60661 17.916 1.50196 12.6936 3.29881 11.3165C6.71962 8.69495 9.45852 18.6586 12.1434 16.3941C14.2295 14.6347 8.80571 8.47584 10.0676 5.54199C12.2783 0.402279 19.9388 11.3165 19.9388 11.3165" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
      <ellipse cx="1.67381" cy="18.0961" rx="1.67381" ry="1.65278" fill="currentColor"/>
      <ellipse cx="20.0058" cy="11.3188" rx="1.67381" ry="1.65278" fill="currentColor"/>
    </svg>
  )
} 